import api from "./api.js";

export default class PayApi {
  static async create(data) {
    return await api.post(`payment`, data);
  }
  static async getList(params) {
    return await api.get(`payment`, params);
  }
  static async getById(paymentId, params) {
    return await api.get(`payment/${paymentId}`, params);
  }
  static async update(paymentId, data) {
    return await api.put(`payment/${paymentId}`, data);
  }
  static async delete(data) {
    return await api.del(`payment`, data);
  }

  static async getMembershipList(params) {
    return await api.get(`membership-info`, params);
  }
  static async getByMembershipId(membershipId, params) {
    return await api.get(`membership-info/${membershipId}`, params);
  }
  static async updateMembershipStatus(membershipId, data) {
    return await api.patch(`membership-info/membership-status/${membershipId}`, data);
  }

  static async updateRefundStatus(paymentId, data) {
    return await api.patch(`payment/payment-status/${paymentId}`, data);
  }
}
